/* eslint-disable jsx-a11y/anchor-is-valid */
import { Grid, Box, Link, makeStyles, Typography } from '@material-ui/core';
import React from 'react';
import { Trans } from 'react-i18next';
import { useI18next } from 'gatsby-plugin-react-i18next';
import momentIt from 'moment/locale/it';
import momentEn from 'moment/locale/en-in';
import moment from 'moment';
import { Event } from './Event';
import { ContainerSection } from '../../../shared/components/ContainerSection';
import { Divider } from '../../../shared/components/Divider';
import { Text } from '../../../shared/components/Text';

const KEY = 'AIzaSyDHk5JQOnUr97HKSXXs-py2Rc6r_kFCPDk';
const CLIENT_ID = '8608oilng304hmi3j133v9cbs0@group.calendar.google.com';

const useStyle = makeStyles(theme => ({
  videoPlaceholder: {
    height: 500,
    backgroundColor: '#000',
    [theme.breakpoints.down('md')]: {
      height: 300,
      margin: '30px auto 0',
    },
  },
  linkStyle: {
    textDecoration: 'underline',
    fontSize: '16px',
    paddingTop: 50,
  },
}));

export const Consulency = () => {
  const styles = useStyle();
  const { i18n } = useI18next();

  const [calendarEvents, setEvents] = React.useState([]);

  React.useEffect(() => {
    if (i18n.language === 'it') {
      moment.locale('it', momentIt);
    } else {
      moment.locale('en', momentEn);
    }

    fetch(
      `https://www.googleapis.com/calendar/v3/calendars/${CLIENT_ID}/events?key=${KEY}`
    )
      .then(response => response.json())
      .then(data => {
        setEvents(data.items.reverse());
      });
  }, [i18n.language]);

  return (
    <ContainerSection position="top" anchor="formazione" title="Consulenza">
      <Grid container spacing={10}>
        <Grid item xs={12} md={6}>
          <Text variant="h4" style={{ fontFamily: 'firaSans', fontSize: 18 }}>
            <Trans>Consulenza aziendale</Trans>
          </Text>
          <Divider height={30} />
          <Text variant="h4" style={{ fontFamily: 'firaSans', fontSize: 18 }}>
            <Trans>Evoluzione</Trans>
          </Text>
          {/* <Divider height={30} />
          <Box className={styles.videoPlaceholder} /> */}
        </Grid>
        {/* <Grid item xs={12} md={6}>
          <Text variant="h3" labelColor="primary" uppercase>
            <Trans>Agenda</Trans>
          </Text>
          <Text variant="h4">
            <Trans>Agg zoom</Trans>
          </Text>
          <Divider height={30} />
          <Box style={{ overflowY: 'scroll', height: 500 }}>
            {calendarEvents.map(events => (
              <>
                <Event
                  summary={events.summary}
                  description={events.description ? events.description : null}
                  day={moment(events.start.dateTime)
                    .format('dddd DD MMMM y')
                    .toString()}
                  start={moment(events.start.dateTime).format('LT').toString()}
                  end={moment(events.end.dateTime).format('LT').toString()}
                />
                <Divider height={20} />
              </>
            ))}
          </Box>
          <Typography variant="h6" className={styles.linkStyle}>
            <Link href="#" color="primary">
              <Trans>Archivio</Trans>
            </Link>
          </Typography>
        </Grid> */}
      </Grid>
    </ContainerSection>
  );
};
